import React from "react";
import { SettingsContainer } from "../../../components/molecules/settingsContainer";
import { DividerAlt } from "../../../components/atoms/dividerAlt";
import { Flex } from "rebass/styled-components";
import { Body } from "../../../components/text";
import { ResetButton } from "../../../components/atoms/form/button/reset";
import { useTranslation } from "react-i18next";

export function ResetPassword() {
  const { t } = useTranslation(`translation`, {
    keyPrefix: "profile.account",
  });
  return (
    <SettingsContainer title={t("managePassword")}>
      <DividerAlt></DividerAlt>
      <Flex alignItems="center" justifyContent="flex-end"></Flex>
      <Body color="chalk" mb={6}>
        {t("managePasswordBody")}
      </Body>
      <Body color="ice" mb={3}>
        {t("resetPassword")}
      </Body>
      <Body color="chalk">{t("resetPasswordBody")}</Body>
      <ResetButton
        mt={[5]}
        size="small"
        classification="secondary"
        flex={true}
        to="/reset"
      >
        {t("resetPassword")}
      </ResetButton>
    </SettingsContainer>
  );
}
